import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getRemoteConfig, isSupported } from "firebase/remote-config";

const firebaseConfig = {
  apiKey: "AIzaSyAKES6Id-9VUKDVy8-P8jiaKwT4RTEMKkQ",
  authDomain: "tickets-niebla.firebaseapp.com",
  projectId: "tickets-niebla",
  storageBucket: "tickets-niebla.firebasestorage.app",
  messagingSenderId: "917268467708",
  appId: "1:917268467708:web:5761f80699f89d33146c79",
  measurementId: "G-S1Z5B8SSK0",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

const getRemoteConfigInstance = async () => {
  if (typeof window === "undefined") {
    return null;
  }

  const remoteConfigSupported = await isSupported();

  if (!remoteConfigSupported) {
    return null;
  }

  const remoteConfig = getRemoteConfig(app);

  remoteConfig.settings = {
    fetchTimeoutMillis: 10000,
    minimumFetchIntervalMillis: 60 * 60 * 1000,
  };

  return remoteConfig;
};

export { app, auth, db, getRemoteConfigInstance };
